require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ../~/angular-cookies/index.js
// module id = 107
// module chunks = 3